<template>
  <v-container fluid grid-list-lg>
    <v-layout justify-space-around row wrap>
      <v-flex xs4 md3 text-xs-right>
        <v-select
          v-model="mes"
          color="secondary"
          :items="meses"
          :options="meses"
          label="Mês"
        ></v-select>
      </v-flex>
      <v-flex xs4 md3 text-xs-right>
        <v-select
          v-model="ano"
          color="secondary"
          :items="anos"
          :options="anos"
          label="Ano"
        ></v-select>
      </v-flex>
      <v-flex xs4 md3 text-xs-right>
        <v-btn
          id="finalizar"
          color="primary"
          class="default-border"
          depressed
          @click="buscarDados()"
          >Pesquisar
        </v-btn>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs12 lg3>
        <v-card color="green" class="white--text">
          <v-card-title primary-title>
            <div>
              <div class="headline">Faturamento Bruto</div>
              <br />
              <span>Entrou no caixa:</span>
              <span class="subheading mr-2">{{
                dados.faturamentoBruto.toLocaleString("pt-br", {
                  style: "currency",
                  currency: "BRL",
                })
              }}</span>
              <br />
            </div>
          </v-card-title>
          <!-- <v-card-actions>
            <v-btn flat dark @click="go('Empresas')">Ver agora</v-btn>
          </v-card-actions> -->
        </v-card>
      </v-flex>
      <v-flex xs12 lg3>
        <v-card color="blue-grey darken-1" class="white--text">
          <v-card-title primary-title>
            <div>
              <div class="headline">Custos Loja</div>
              <span>Despesas pagas:</span>
              <span class="subheading mr-2">{{
                dados.custo.toLocaleString("pt-br", {
                  style: "currency",
                  currency: "BRL",
                })
              }}</span>
              <br />
              <span>Descontos aplicados:</span>
              <span class="subheading mr-2">{{
                dados.descontos.toLocaleString("pt-br", {
                  style: "currency",
                  currency: "BRL",
                })
              }}</span>
            </div>
          </v-card-title>
          <!-- <v-card-actions>
            <v-btn flat dark @click="go('Agendas')">Ver agora</v-btn>
          </v-card-actions> -->
        </v-card>
      </v-flex>
      <v-flex xs12 lg3>
        <v-card color="purple darken-2" class="white--text">
          <v-card-title primary-title>
            <div>
              <div class="headline">Custo de Prod. Vendidos</div>
              <br />
              <span>Gasto nos produtos:</span>
              <span class="subheading mr-2">{{
                dados.custoProdutos.toLocaleString("pt-br", {
                  style: "currency",
                  currency: "BRL",
                })
              }}</span>
              <br />
            </div>
          </v-card-title>
          <!-- <v-card-actions>
            <v-btn flat dark @click="go('Pessoas')">Ver agora</v-btn>
          </v-card-actions> -->
        </v-card>
      </v-flex>

      <v-flex xs12 lg3>
        <v-card
          :color="this.dados.resultado > 0 ? '#26c6da' : 'red'"
          class="white--text"
        >
          <v-card-title primary-title>
            <div>
              <div class="headline">Resultado Líquido</div>
              <br />
              <span>(Fat. Bruto - (Custos Loja + Custo Produto))</span>
              <span class="subheading mr-2">{{
                dados.resultado.toLocaleString("pt-br", {
                  style: "currency",
                  currency: "BRL",
                })
              }}</span>
            </div>
          </v-card-title>
          <!-- <v-card-actions>
            <v-btn flat dark @click="go('Contas')">Ver agora</v-btn>
          </v-card-actions> -->
        </v-card>
      </v-flex>
      <v-flex xs12 lg3>
        <v-card color="purple" class="white--text">
          <v-card-title primary-title>
            <div>
              <div class="headline">Ticket médio</div>
              <span>Ticket Venda:</span>
              <span class="subheading mr-2">{{
                dados.tmedioFBruto.toLocaleString("pt-br", {
                  style: "currency",
                  currency: "BRL",
                })
              }}</span>
              <br />
              <span>Ticket Lucro:</span>
              <span class="subheading mr-2">{{
                dados.tmedioLucro.toLocaleString("pt-br", {
                  style: "currency",
                  currency: "BRL",
                })
              }}</span>
              <br />
            </div>
          </v-card-title>
          <!-- <v-card-actions>
            <v-btn flat dark @click="go('Empresas')">Ver agora</v-btn>
          </v-card-actions> -->
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import usuarioHelper from "@/helpers/usuario.js";
import jwt from "@/helpers/jwt";

export default {
  name: "CustoVSReceita",
  data: () => ({
    dados: {
      faturamentoBruto: 0,
      custo: 0,
      descontos: 0,
      custoProdutos: 0,
      resultado: 0,
      tmedioFBruto: 0,
      tmedioLucro: 0,
    },
    ano: null,
    mes: null,
    meses: [
      { value: "1", text: "Jan" },
      { value: "2", text: "Fev" },
      { value: "3", text: "Mar" },
      { value: "4", text: "Abr" },
      { value: "5", text: "Mai" },
      { value: "6", text: "Jun" },
      { value: "7", text: "Jul" },
      { value: "8", text: "Ago" },
      { value: "9", text: "Set" },
      { value: "10", text: "Out" },
      { value: "11", text: "Nov" },
      { value: "12", text: "Dez" },
    ],
    anos: [
      { value: "2020", text: "2020" },
      { value: "2021", text: "2021" },
      { value: "2022", text: "2022" },
      { value: "2023", text: "2023" },
      { value: "2024", text: "2024" },
      { value: "2025", text: "2025" },
      { value: "2026", text: "2026" },
    ],
  }),
  mounted: function () {
    //this.$store.commit("startLoading");
    //this.buscarDados();
    this.ano = new Date().getFullYear() + "";
    this.mes = new Date().getMonth() + 1 + "";
    //this.$store.commit("endLoading");
  },
  computed: {
    usuarioLogado: function () {
      return usuarioHelper.USUARIO_LOGADO();
    },
  },
  methods: {
    buscarDados: function () {
      const self = this;

      self.$http
        .get(
          `${process.env.URL_API}/custovsreceita/v1/busca/relatoriomensalcustovsreceita/conta/` +
            jwt.decryptToken().idconta +
            `/mes/` +
            self.mes +
            `/ano/` +
            self.ano,
          {
            headers: {
              Authorization:
                "Bearer " + JSON.parse(localStorage.getItem("token")),
            },
          }
        )
        .then(function (response) {
          const data = response.data;

          if (
            data.relatorioCaixaModel != null &&
            data.relatorioCustoModel != null
          ) {
            self.dados.faturamentoBruto = data.relatorioCaixaModel.valorCaixa;
            self.dados.descontos = data.relatorioCaixaModel.valorDescontos;
            self.dados.custo = data.relatorioCustoModel.valor;
            self.dados.custoProdutos =
              data.relatorioCaixaModel.valorCaixa -
              data.relatorioCaixaModel.valorLucro;

            self.dados.resultado =
              data.relatorioCaixaModel.valorCaixa - (
              data.relatorioCustoModel.valor + self.dados.custoProdutos);

            self.dados.tmedioFBruto =
              data.relatorioCaixaModel.valorCaixa /
              data.relatorioCaixaModel.numeroVendas;

            self.dados.tmedioLucro =
              data.relatorioCaixaModel.valorLucro /
              data.relatorioCaixaModel.numeroVendas;
          } else {
            alert("Não a dados para esse mês !");
            self.dados.faturamentoBruto = 0;
            self.dados.descontos = 0;
            self.dados.custo = 0;
            self.dados.custoProdutos = 0;
            self.dados.resultado = 0;
            self.dados.tmedioFBruto = 0;
            self.dados.tmedioLucro = 0;
          }
        });
    },
    go: function (routeName, routeParams) {
      const self = this;
      if (this.$router.currentRoute.name != routeName) {
        if (!routeParams) {
          self.$router.push({ name: routeName });
        } else {
          self.$router.push({ name: routeName, params: routeParams });
        }
      }
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/relatorio/CustoVSReceita.vue